import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PhysicianConsultationTab from "../Components/PhysicianConsultationTab";
import { file, userpatient, chat } from "../Constant/Index";

const PhysicianCurrentConsultationsDetail = () => {
	const [files, setFiles] = useState([]);

	const handleFileChange = (e) => {
		const newFiles = [...files];
		newFiles[parseInt(e.target.id.split("-").pop(), 10) - 1] =
			e.target.files[0];
		setFiles(newFiles);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(files); // Replace with your form submission logic
	};

	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PhysicianProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center  justify-content-between w-100">
										<h5 class="main-heading level-6 ps-3 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											My Consultations
										</h5>
										<PhysicianConsultationTab />
									</div>
								</div>
								<div className="row">
									<div class="col-lg-12">
										<div class="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img src={userpatient} className="img-fluid" alt="" />
												<div>
													<h4 class="main-heading-font level-6 ">John Doe</h4>
													<h5 class="primary-medium-font level-8 extra-color-15">
														Patient
													</h5>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-lg-12">
										<div class="order-detail-content">
											<div class="row">
												<div class="col-lg-12">
													<div class="details-pharmacy">
														<h4 class="main-heading-font level-6 ">Symptoms</h4>
														<h5 class="primary-medium-font level-8 extra-color-10">
															Allergy
														</h5>
													</div>
												</div>
												<div class="col-lg-12 mt-3">
													<div class="details-pharmacy">
														<h4 class="main-heading-font level-6 ">Details</h4>
														<h5 class="primary-medium-font level-8 extra-color-10">
															Nullam iaculis metus nec mauris egestas convallis.
															Praesent sit amet urna libero. Aliquam efficitur
															gravida dui, vel accumsan massa vehicula ut.
															Aliquam felis.
														</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<form onSubmit={handleSubmit}>
									<div className="row input-file-wrapper mt-3">
										<div className="form-group col-lg-12">
											<div className="position-relative">
												<div className="form-group col-lg-12">
													<div className="pdf-icon">
														<i class="fa-solid fa-file-pdf"></i>
													</div>
													<input
														type="file"
														accept="application/pdf"
														onChange={handleFileChange}
														className="form-control"
													/>
													<div className="icon-input">
														<h4>
															{" "}
															<Link className="download" to="/">
																{" "}
																Download{" "}
															</Link>
														</h4>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="row input-file-wrapper">
										<div className="form-group col-lg-12">
											<div className="position-relative">
												<div className="form-group col-lg-12">
													<div className="pdf-icon">
														<i class="fa-solid fa-file-pdf"></i>
													</div>
													<input
														type="file"
														accept="application/pdf"
														onChange={handleFileChange}
														className="form-control"
													/>
													<div className="icon-input">
														<h4>
															{" "}
															<Link className="download" to="/">
																{" "}
																Download{" "}
															</Link>
														</h4>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row border-top pt-2 mt-2  pb-2 ">
										<div className="col-lg-6">
											<Link
												class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												to="/write-prescription"
											>
												<span class="bg-wrapper w-100">
													{" "}
													<img
														src={file}
														className="img-fluid pe-3"
														alt=""
													/>{" "}
													Write Prescription
												</span>
											</Link>
										</div>
										<div className="col-lg-6">
											<Link
												class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												to="/physician-write-notes"
											>
												<span class="bg-wrapper w-100">
													{" "}
													<img
														src={file}
														className="img-fluid pe-3"
														alt=""
													/>{" "}
													Write Notes
												</span>
											</Link>
										</div>
									</div>
									<div class="row mt-4">
										<div class="col-lg-12">
											<Link
												class="color-view-details detail-physician-btn calender-bg  w-100 d-flex align-items-center justify-content-center dark-color"
												to="/physician-current-chat"
											>
												<span>
													<img src={chat} alt="" className="img-fluid" />
												</span>
												View Chat
											</Link>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianCurrentConsultationsDetail;
